import React from "react";
import { Button } from "../..";

export default function BecomePartner(props) {
	return (
		<section className="welcome-section no-pt">
			<h2>Community-based learning</h2>

			<ul>
				<li>
					<p className="text-justify">
						We support community-based learning and development? You
						can register your community/organization/association for
						a tailored learning session for your members. We would
						love to support your community!
					</p>
				</li>
			</ul>

			<Button linkTo="https://bit.ly/3HPartners">Register now</Button>
		</section>
	);
}
